import { useEffect, useRef } from "react";

const NodeBackground = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        let width = canvas.parentElement.offsetWidth;
        let height = canvas.parentElement.offsetHeight;

        canvas.width = width;
        canvas.height = height;

        const isMobile = window.innerWidth <= 768; // mobile threshold
        const NODE_COUNT = isMobile ? 40 : 105; // fewer nodes on mobile
        const nodes = [];

        for (let i = 0; i < NODE_COUNT; i++) {
            nodes.push({
                x: Math.random() * width,
                y: Math.random() * height,
                vx: (Math.random() - 0.5) * 0.3, // optional: slower movement
                vy: (Math.random() - 0.5) * 0.3,
                life: Math.random() * 50 + 100
                // increased from 200+100 to 300+200
            });
        }

        const draw = () => {
            ctx.clearRect(0, 0, width, height);

            // draw lines
            for (let i = 0; i < nodes.length; i++) {
                for (let j = i + 1; j < nodes.length; j++) {
                    const dx = nodes[i].x - nodes[j].x;
                    const dy = nodes[i].y - nodes[j].y;
                    const dist = Math.sqrt(dx * dx + dy * dy);

                    const maxDist = isMobile ? 100 : 150; // shorter lines on mobile
                    if (dist < maxDist) {
                        ctx.strokeStyle = `rgba(63,160,192,${(1 - dist / 150) * 0.35})`;
                        ctx.lineWidth = 1;
                        ctx.beginPath();
                        ctx.moveTo(nodes[i].x, nodes[i].y);
                        ctx.lineTo(nodes[j].x, nodes[j].y);
                        ctx.stroke();

                        // pull nodes slightly together
                        // const pullStrength = 0.00002; // smaller = slower, less distracting
                        const pullStrength = 0.0000005; // smaller = slower, less distracting
                        nodes[i].vx -= dx * pullStrength;
                        nodes[i].vy -= dy * pullStrength;
                        nodes[j].vx += dx * pullStrength;
                        nodes[j].vy += dy * pullStrength;
                    }
                }
            }

            // draw nodes
            nodes.forEach((node, index) => {
                node.x += node.vx;
                node.y += node.vy;
                node.life -= 0.5;

                ctx.beginPath();
                ctx.arc(node.x, node.y, 2.5, 0, Math.PI * 2);
                ctx.fillStyle = isMobile ? "rgba(120, 140, 160, 0.15)" : "rgba(120, 140, 160, 0.25)";
                // ctx.fillStyle = "rgba(180, 210, 230, 0.55)";
                ctx.fill();

                // respawn node
                if (node.life <= 0) {
                    nodes[index] = {
                        x: Math.random() * width,
                        y: Math.random() * height,
                        vx: (Math.random() - 0.5) * 0.3,
                        vy: (Math.random() - 0.5) * 0.3,
                        // life: Math.random() * 200 + 100
                        life: Math.random() * 50 + 100
                    };
                }
            });

            requestAnimationFrame(draw);
        };

        draw();

        const resize = () => {
            width = canvas.parentElement.offsetWidth;
            height = canvas.parentElement.offsetHeight;
            canvas.width = width;
            canvas.height = height;
        };

        resize();
        window.addEventListener("resize", resize);
        return () => window.removeEventListener("resize", resize);

    }, []);

    return (
        <div className="hero-background">
            <canvas ref={canvasRef} />
        </div>
    );
};

export default NodeBackground;